import { RestService, Rest } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { CreateActivityReportInput, ProgressValidationDto } from '../progresses/dtos/models';

@Injectable({
  providedIn: 'root',
})
export class ActivityReportService {
  private restService = inject(RestService);
  apiName = 'Default';
  

  createByInput = (input: CreateActivityReportInput, config?: Partial<Rest.Config>) =>
    this.restService.request<any, ProgressValidationDto>({
      method: 'POST',
      url: '/api/app/activity-report',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  rejectBySourceId = (sourceId: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, ProgressValidationDto>({
      method: 'POST',
      url: `/api/app/activity-report/reject/${sourceId}`,
    },
    { apiName: this.apiName,...config });
}